import { render, staticRenderFns } from "./InspirationIcon.vue?vue&type=template&id=63033e98"
import script from "./InspirationIcon.vue?vue&type=script&lang=js"
export * from "./InspirationIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports